





















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ExStore } from 'vuex'
import { MediaComponentProps } from '@/components/common/videoCallRoom/VideoCallRoomContainer.vue'
import HavingWebRTCMediaMixin from '@/mixins/webrtc/havingWebRTCMediaMixin'

@Component
export default class VideoCallSubScreen extends mixins(HavingWebRTCMediaMixin) {
  @Prop(Object) participant!: MediaComponentProps

  $store!: ExStore

  get shareScreenActive() {
    return this.$store.getters['videoCallRoom/shareScreenActive']
  }

  get localVideoActive() {
    return this.$store.getters['videoCallRoom/videoActive']
  }

  get screenActive() {
    return this.participant.isLocal
      ? this.localVideoActive
      : !this.remoteVideoSignalMuted
  }

  get participantFullName() {
    return `${this.participant.lastName}${this.participant.firstName}`
  }

  handleClickSubScreen() {
    this.$emit('select', this.participant.id)
  }

  mounted() {
    const { stream, muted } = this.participant
    this.initialize(stream, muted)
  }
}
